import React, {
    ChangeEventHandler,
    FocusEventHandler,
    ReactNode,
    useState,
} from 'react';
import { SvgIconTypeMap, TextField, Tooltip } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { FormikTouched } from 'formik/dist/types';
import { IconFieldText } from './iconFieldText';
import { OverridableComponent } from '@mui/material/OverridableComponent';

type Props = {
    label?: string;
    name: string;
    type?: string | undefined;
    placeholder?: string | undefined;
    autoComplete?: string;
    size?: 'small' | 'medium' | undefined;
    margin?: 'dense' | 'normal' | 'none';
    required?: false | boolean;
    value?: string | undefined;
    rows?: number;
    touched?: boolean | FormikTouched<any> | FormikTouched<any>[] | undefined;
    errors?: any;
    disabled?: boolean;
    tooltipText?: string | ReactNode | undefined;
    tooltipWidth?: string | number | undefined;
    onChange?: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onBlur?: FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
    onClickIcon?: () => void;
    Icon?: OverridableComponent<SvgIconTypeMap> & { muiName: string };
};

const FieldText = ({
    label,
    name,
    type,
    placeholder,
    autoComplete,
    size = 'small',
    margin,
    required,
    rows,
    touched,
    errors,
    value,
    disabled,
    tooltipText,
    tooltipWidth = 300,
    onChange,
    onBlur,
    onClickIcon,
    Icon,
}: Props) => {
    //onChange Formik
    //The variable filedTextFormik must be equal to the variable name of the formik
    //onChange={formik.handleChange}

    const [showPass, setShowPass] = useState(false);

    return (
        <Tooltip
            title={tooltipText || ''}
            arrow
            componentsProps={{
                tooltip: {
                    sx: {
                        maxWidth: tooltipWidth,
                    },
                },
            }}
        >
            <TextField
                id="field"
                autoComplete={autoComplete}
                fullWidth
                multiline={!!rows}
                placeholder={placeholder}
                label={label}
                name={name}
                value={value}
                required={required}
                rows={rows}
                margin={margin}
                type={
                    type === 'password'
                        ? showPass
                            ? 'text'
                            : 'password'
                        : type
                }
                disabled={disabled}
                onChange={onChange}
                onBlur={onBlur}
                size={size}
                helperText={touched ? errors : ''}
                error={touched && Boolean(errors)}
                sx={{
                    '& label.Mui-focused': {
                        color: 'primary.main',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: 'primary.main',
                    },
                    '& .MuiFilledInput-underline:after': {
                        borderBottomColor: 'primary.main',
                    },
                    '& .MuiOutlinedInput-root': {
                        '&.Mui-focused fieldset': {
                            borderColor: 'primary.main',
                        },
                    },
                }}
                InputProps={{
                    endAdornment: (
                        <IconFieldText
                            onClick={
                                onClickIcon
                                    ? onClickIcon
                                    : type === 'password'
                                        ? () => setShowPass(!showPass)
                                        : undefined
                            }
                            Icon={
                                Icon
                                    ? Icon
                                    : type === 'password'
                                        ? showPass
                                            ? VisibilityOffIcon
                                            : VisibilityIcon
                                        : undefined
                            }
                        />
                    ),
                }}
            />
        </Tooltip>
    );
};

export default FieldText;
